import { ReactNode } from 'react';
import { Policy } from '../../../types/user';
import { useGetCurrentUserQuery } from '../../../api/userApi';

type Props = {
  children?: ReactNode;
  /** ポリシーがなかったときに代わりにレンダリングする要素 */
  fallback?: ReactNode;
} & Requirement;
type Requirement =
  | {
      /** 必要なポリシー */
      policy: Policy;
    }
  | {
      /** 必要なポリシー (いずれか満たせばよい) */
      anyPolicy: ReadonlyArray<Policy>;
    };

/**
 * 現在ログイン中のユーザーが特定のポリシーを持っているときのみ children をレンダリングするコンポーネント
 */
function PolicyRequired({ children, fallback = null, ...rest }: Props) {
  const hasPolicy = useHasPolicy(rest);
  return <>{hasPolicy ? children : fallback}</>;
}

export default PolicyRequired;

function useHasPolicy(requirement: Requirement) {
  const { data } = useGetCurrentUserQuery();
  const policies = data?.policies ?? [];
  if ('anyPolicy' in requirement)
    return policies.some((p) => requirement.anyPolicy.includes(p));
  return policies.includes(requirement.policy);
}
